import { createGlobalStyle, css } from "styled-components";
import "normalize.css";
import "system-font-css";
import RubikLight from "../../assets/fonts/Rubik/Rubik-Light.ttf";
import RubikRegular from "../../assets/fonts/Rubik/Rubik-Regular.ttf";
import RubikMedium from "../../assets/fonts/Rubik/Rubik-Medium.ttf";
import RubikSemiBold from "../../assets/fonts/Rubik/Rubik-SemiBold.ttf";
import RubikBold from "../../assets/fonts/Rubik/Rubik-Bold.ttf";

const globalStyles = css`
  @font-face {
    font-family: Rubik;
    font-weight: 300;
    src: url(${RubikLight});
  }

  @font-face {
    font-family: Rubik;
    font-weight: 400;
    src: url(${RubikRegular});
  }

  @font-face {
    font-family: Rubik;
    font-weight: 500;
    src: url(${RubikMedium});
  }

  @font-face {
    font-family: Rubik;
    font-weight: 600;
    src: url(${RubikSemiBold});
  }
  @font-face {
    font-family: Rubik;
    font-weight: 700;
    src: url(${RubikBold});
  }

  html {
    box-sizing: border-box;
    font-size: calc(14px + 0.25vw);
    font-family: Rubik;
    width: 100vw;
    height: 100vh;
    min-height: 100vh;
    scrollbar-color: transparent;
    scrollbar-width: thin;
    padding: 0;
    margin: 0;
    overflow-y: hidden;
    overflow-x: hidden;
  }

  body {
    width: 100%;
    height: 100%;
    font-family: Rubik;
    min-height: 100vh;
    scrollbar-color: transparent;
    padding: 0;
    margin: 0;
    overflow-y: hidden;
    overflow-x: hidden;
  }

  html,
  body {
    margin: 0;
    padding: 0;
    height: 100%;
    overflow-x: hidden;
  }
  /* WebKit and Chromiums */
  ::-webkit-scrollbar {
    background-color: transparent;
    border-radius: 5px;
    scrollbar-width: thin;
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 5px;
    scrollbar-width: thin;
    width: 8px;
    height: 8px;
  }

  .MuiPickersDateRangePickerInput-root {
    align-items: center !important;
  }

  .MuiTypography-body1 {
  }

  .MuiTypography-root {
    font-size: 16px;
    margin-inline-start: 10px;
  }
  .MuiPopover-paper {
    max-height: 200px !important;
  }

  .MuiTabPanel-root {
    padding: 0 !important;
  }

  body[dir="rtl"] {
    direction: rtl;
    .MuiSelect-icon {
      right: auto;
    }
  }
  *,
  *:before,
  *:after {
    box-sizing: inherit;
    outline: none;
  }

  *:focus {
    outline: none;
  }

  textarea:focus,
  input:focus {
    outline: none;
  }

  a {
    text-decoration: none;
    color: #2460c3;
    &:hover {
      border-bottom: 1px solid #4373c3;
    }
  }

  .MuiInputBase-input-MuiOutlinedInput-input {
    line-height: 1em !important;
  }
  .input {
    line-height: 1em !important;
  }

  .modal {
    background-color: red;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  .ql_xxx {
    color: #fff;
    border-radius: 25px;
    margin: 0 5px;
    padding: 5px 15px;
    background-color: #3b67ad;
    white-space: nowrap;
  }
`;

const GlobalStyles = createGlobalStyle`${globalStyles}`;
GlobalStyles.css = globalStyles;

export default GlobalStyles;
